import { useQuery } from "react-query";
import { z } from "zod";
import { AuditableSchema } from "~/types";
import { agent } from "~/util/agent";

const AuditEventSchema = z
  .object({
    data: z.any(),
    org_id: z.string().uuid().min(1),
    member_id: z.string().uuid().min(1),
    request_id: z.string().uuid().min(1),
    event_type: z.string().trim().min(1),
  })
  .merge(AuditableSchema);

type AuditEventResourceType = z.infer<typeof AuditEventSchema>;

const QUERY_AUDITS_KEY = "audit-events";

const useAuditEvents = () =>
  useQuery([QUERY_AUDITS_KEY], async () => agent("audit_events/").json<AuditEventResourceType[]>());

const useAuditEvent = (id?: string) =>
  useQuery([QUERY_AUDITS_KEY, id], async () => agent(`audit_events/${id}`).json<AuditEventResourceType>(), {
    enabled: !!id,
  });

export type { AuditEventResourceType };
export { QUERY_AUDITS_KEY, AuditEventSchema, useAuditEvents, useAuditEvent };
